import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../services/bao-service";
import baoDialog from "./bao-dialog";
import template from "./qr-dialog.html";
function QrDialog(text, label) {
    var self = this;
    self.Bao = Bao;
    self.Width = ko.observable();
    self.Text = ko.observable(text);
    self.Url = ko.observable();
    self.Label = ko.observable(label);
    self.Width.subscribe(function () {
        setUrl();
    });
    self.Text.subscribe(function () {
        setUrl();
    });
    var setUrl = function () {
        var url = "";
        if (!Bao.Utils.String.IsNullOrWhitespace(self.Text())) {
            url = Bao.AbsolutePath + "Bao/Qr?text=" + encodeURIComponent(self.Text());
            if (self.Width() != null && typeof self.Width() === "number") {
                url = url + "&width=" + self.Width();
            }
        }
        self.Url(url);
    };
    setUrl();
    self.Open = function () {
        var def = $.Deferred();
        def.resolve();
        var dialog = new baoDialog(Bao.Session.ApplicationName);
        dialog.Buttons([{
                Title: ko.observable("Download"),
                Click: function () {
                    if (!Bao.Utils.String.IsNullOrWhitespace(self.Url())) {
                        window.open(self.Url(), "_blank");
                    }
                },
                Enabled: ko.observable(true)
            }, {
                Title: Bao.Session.GetMessage("msgClose"),
                Click: function () {
                    dialog.Close();
                },
                Enabled: ko.observable(true)
            }]);
        dialog.Width("450px");
        dialog.ViewModel(self);
        dialog.Template(template);
        dialog.Open();
        return def.promise();
    };
}
export default QrDialog;